var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkinWithHair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_8354)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99917 11.8544C7.99853 12.1326 7.95991 12.4122 7.88212 12.6794C7.8045 12.9459 7.68624 13.2054 7.52353 13.4375C7.36072 13.6697 7.14931 13.8799 6.88818 14.0337L6.88767 14.034C6.63808 14.1809 6.35204 14.2704 6.04794 14.2785C5.72452 14.3017 5.41215 14.2286 5.13752 14.0829L5.13697 14.0826C4.85126 13.9308 4.62388 13.7106 4.45336 13.4675C4.28278 13.2241 4.163 12.9499 4.08932 12.6699C4.01733 12.3962 3.98734 12.1102 3.99829 11.8278C4.00255 11.4455 4.10398 10.6058 4.24022 9.64918C4.38478 8.63424 4.58313 7.39226 4.79958 6.18837C5.01529 4.9886 5.25227 3.80816 5.47511 2.92393C5.58499 2.48795 5.69987 2.08949 5.817 1.78908C5.87249 1.64676 5.94942 1.47079 6.05481 1.31548C6.1062 1.23974 6.19849 1.11722 6.34133 1.00962C6.48863 0.898655 6.77009 0.747243 7.13992 0.799822C7.63287 0.869904 7.99917 1.29196 7.99917 1.78987V11.8544ZM4.99815 11.8521C4.98929 12.0437 5.00915 12.2358 5.0564 12.4154C5.10365 12.595 5.17719 12.7579 5.27203 12.8933C5.36688 13.0285 5.48083 13.1329 5.60618 13.1995C5.73154 13.266 5.86538 13.2932 5.99866 13.2791C6.12958 13.2798 6.25932 13.2435 6.38047 13.1722C6.50162 13.1008 6.61179 12.996 6.70471 12.8634C6.79762 12.7309 6.87145 12.5734 6.92198 12.3999C6.9725 12.2264 6.99874 12.0403 6.99917 11.8521V1.78987C6.99401 1.78913 6.98878 1.78914 6.98348 1.78987C6.74291 1.82299 6.36273 3.35141 5.99917 5.21418C5.48184 7.86478 4.99815 11.1924 4.99815 11.8521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9992 11.8546C19.9985 12.1326 19.9599 12.4121 19.8822 12.6793L19.882 12.6798C19.8044 12.9461 19.6862 13.2054 19.5235 13.4375C19.3607 13.6698 19.1493 13.8799 18.8882 14.0337L18.8877 14.034C18.6381 14.1809 18.3521 14.2704 18.0479 14.2785C17.7246 14.3017 17.4121 14.2286 17.1375 14.0829L17.1369 14.0826C16.8514 13.9308 16.6239 13.7107 16.4533 13.4675C16.2827 13.224 16.163 12.9499 16.0893 12.6701C16.0174 12.3965 15.9873 12.1102 15.9983 11.8277C16.0026 11.4454 16.104 10.6057 16.2402 9.64918C16.3848 8.63424 16.5831 7.39226 16.7996 6.18837C17.0153 4.9886 17.2523 3.80816 17.4751 2.92393C17.585 2.48795 17.6999 2.08949 17.817 1.78908C17.8725 1.64676 17.9494 1.47079 18.0548 1.31548C18.1062 1.23974 18.1985 1.11722 18.3413 1.00962C18.4886 0.898655 18.7701 0.747243 19.1399 0.799822C19.6329 0.869903 19.9992 1.29196 19.9992 1.78987V11.8546ZM16.9981 11.8521C16.9893 12.0437 17.0092 12.2358 17.0564 12.4154C17.1037 12.595 17.1772 12.7579 17.272 12.8933C17.3669 13.0285 17.4809 13.1329 17.6062 13.1995C17.7315 13.266 17.8654 13.2932 17.9987 13.2791C18.1296 13.2798 18.2593 13.2435 18.3805 13.1722C18.5016 13.1008 18.6118 12.996 18.7047 12.8634C18.7976 12.7309 18.8714 12.5734 18.922 12.3999C18.9725 12.2264 18.9987 12.0403 18.9992 11.8521V1.78987C18.994 1.78913 18.9888 1.78914 18.9835 1.78987C18.7429 1.82299 18.3627 3.35141 17.9992 5.21417C17.4818 7.86477 16.9981 11.1924 16.9981 11.8521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 16.2622C0.888034 16.2622 1 16.1503 1 16.0122C1 15.8742 0.888164 15.7622 0.75 15.7622V15.2622C0.335824 15.2622 0 15.5979 0 16.0122C0 16.4263 0.335694 16.7622 0.75 16.7622V16.2622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 15.2622C1.16418 15.2622 1.5 15.5979 1.5 16.0122C1.5 16.4263 1.16431 16.7622 0.75 16.7622V16.2622C0.611966 16.2622 0.5 16.1503 0.5 16.0122C0.5 15.8742 0.611836 15.7622 0.75 15.7622V15.2622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 16.2622C12.388 16.2622 12.5 16.1502 12.5 16.0122C12.5 15.8742 12.3882 15.7622 12.25 15.7622V15.2622C11.8358 15.2622 11.5 15.598 11.5 16.0122C11.5 16.4262 11.8356 16.7622 12.25 16.7622V16.2622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 15.2622C12.6642 15.2622 13 15.598 13 16.0122C13 16.4262 12.6644 16.7622 12.25 16.7622V16.2622C12.112 16.2622 12 16.1502 12 16.0122C12 15.8742 12.1118 15.7622 12.25 15.7622V15.2622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 16.2622C12.388 16.2622 12.5 16.1502 12.5 16.0122C12.5 15.8742 12.3882 15.7622 12.25 15.7622V15.2622C11.8358 15.2622 11.5 15.598 11.5 16.0122C11.5 16.4262 11.8356 16.7622 12.25 16.7622V16.2622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 15.2622C12.6642 15.2622 13 15.598 13 16.0122C13 16.4262 12.6644 16.7622 12.25 16.7622V16.2622C12.112 16.2622 12 16.1502 12 16.0122C12 15.8742 12.1118 15.7622 12.25 15.7622V15.2622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 22.7183C0.888034 22.7183 1 22.6063 1 22.4683C1 22.3302 0.888034 22.2183 0.75 22.2183V21.7183C0.335824 21.7183 0 22.054 0 22.4683C0 22.8825 0.335824 23.2183 0.75 23.2183V22.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 21.7183C1.16418 21.7183 1.5 22.054 1.5 22.4683C1.5 22.8825 1.16418 23.2183 0.75 23.2183V22.7183C0.611966 22.7183 0.5 22.6063 0.5 22.4683C0.5 22.3302 0.611966 22.2183 0.75 22.2183V21.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 22.7183C6.88803 22.7183 7 22.6063 7 22.4683C7 22.3302 6.88803 22.2183 6.75 22.2183V21.7183C6.33583 21.7183 6 22.054 6 22.4683C6 22.8825 6.33583 23.2183 6.75 23.2183V22.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 21.7183C7.16417 21.7183 7.5 22.054 7.5 22.4683C7.5 22.8825 7.16417 23.2183 6.75 23.2183V22.7183C6.61197 22.7183 6.5 22.6063 6.5 22.4683C6.5 22.3302 6.61197 22.2183 6.75 22.2183V21.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 22.7183C14.888 22.7183 15 22.6063 15 22.4683C15 22.3302 14.888 22.2183 14.75 22.2183V21.7183C14.3358 21.7183 14 22.054 14 22.4683C14 22.8825 14.3358 23.2183 14.75 23.2183V22.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 21.7183C15.1642 21.7183 15.5 22.054 15.5 22.4683C15.5 22.8825 15.1642 23.2183 14.75 23.2183V22.7183C14.612 22.7183 14.5 22.6063 14.5 22.4683C14.5 22.3302 14.612 22.2183 14.75 22.2183V21.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 22.7183C20.888 22.7183 21 22.6063 21 22.4683C21 22.3302 20.888 22.2183 20.75 22.2183V21.7183C20.3358 21.7183 20 22.054 20 22.4683C20 22.8825 20.3358 23.2183 20.75 23.2183V22.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 21.7183C21.1642 21.7183 21.5 22.054 21.5 22.4683C21.5 22.8825 21.1642 23.2183 20.75 23.2183V22.7183C20.612 22.7183 20.5 22.6063 20.5 22.4683C20.5 22.3302 20.612 22.2183 20.75 22.2183V21.7183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 19.2417C3.38816 19.2417 3.5 19.1298 3.5 18.9917C3.5 18.8536 3.38803 18.7417 3.25 18.7417V18.2417C2.8357 18.2417 2.5 18.5776 2.5 18.9917C2.5 19.406 2.83583 19.7417 3.25 19.7417V19.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 18.2417C3.6643 18.2417 4 18.5776 4 18.9917C4 19.406 3.66417 19.7417 3.25 19.7417V19.2417C3.11184 19.2417 3 19.1298 3 18.9917C3 18.8536 3.11197 18.7417 3.25 18.7417V18.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 19.2417C9.38816 19.2417 9.5 19.1298 9.5 18.9917C9.5 18.8536 9.38803 18.7417 9.25 18.7417V18.2417C8.8357 18.2417 8.5 18.5776 8.5 18.9917C8.5 19.406 8.83583 19.7417 9.25 19.7417V19.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 18.2417C9.6643 18.2417 10 18.5776 10 18.9917C10 19.406 9.66417 19.7417 9.25 19.7417V19.2417C9.11184 19.2417 9 19.1298 9 18.9917C9 18.8536 9.11197 18.7417 9.25 18.7417V18.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 19.2417C9.38816 19.2417 9.5 19.1298 9.5 18.9917C9.5 18.8536 9.38803 18.7417 9.25 18.7417V18.2417C8.8357 18.2417 8.5 18.5776 8.5 18.9917C8.5 19.406 8.83583 19.7417 9.25 19.7417V19.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 18.2417C9.6643 18.2417 10 18.5776 10 18.9917C10 19.406 9.66417 19.7417 9.25 19.7417V19.2417C9.11184 19.2417 9 19.1298 9 18.9917C9 18.8536 9.11197 18.7417 9.25 18.7417V18.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 19.2417C17.3882 19.2417 17.5 19.1297 17.5 18.9917C17.5 18.8537 17.388 18.7417 17.25 18.7417V18.2417C16.8356 18.2417 16.5 18.5777 16.5 18.9917C16.5 19.4059 16.8358 19.7417 17.25 19.7417V19.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18.2417C17.6644 18.2417 18 18.5777 18 18.9917C18 19.4059 17.6642 19.7417 17.25 19.7417V19.2417C17.1118 19.2417 17 19.1297 17 18.9917C17 18.8537 17.112 18.7417 17.25 18.7417V18.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 19.2417C23.3882 19.2417 23.5 19.1297 23.5 18.9917C23.5 18.8537 23.388 18.7417 23.25 18.7417V18.2417C22.8356 18.2417 22.5 18.5777 22.5 18.9917C22.5 19.4059 22.8358 19.7417 23.25 19.7417V19.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 18.2417C23.6644 18.2417 24 18.5777 24 18.9917C24 19.4059 23.6642 19.7417 23.25 19.7417V19.2417C23.1118 19.2417 23 19.1297 23 18.9917C23 18.8537 23.112 18.7417 23.25 18.7417V18.2417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5C0.223858 12.5 0 12.7239 0 13C0 13.2761 0.223858 13.5 0.5 13.5H2.30232C2.8072 15.5898 4.58266 16.6454 6.3107 16.6525C8.0408 16.6596 9.78824 15.6135 10.2143 13.5H13.8023C14.3072 15.5898 16.0827 16.6454 17.8107 16.6525C19.5408 16.6596 21.2882 15.6135 21.7143 13.5H23.5C23.7761 13.5 24 13.2761 24 13C24 12.7239 23.7761 12.5 23.5 12.5H21.626C21.1943 12.5 20.8245 12.8087 20.7473 13.2334C20.4523 14.8561 19.1615 15.658 17.8148 15.6525C16.4637 15.647 15.123 14.8263 14.76 13.2036C14.6693 12.7981 14.3084 12.5 13.8844 12.5H10.126C9.69433 12.5 9.32445 12.8087 9.24726 13.2334C8.9523 14.8561 7.6615 15.658 6.31481 15.6525C4.96366 15.647 3.62304 14.8263 3.26004 13.2036C3.16932 12.7981 2.80841 12.5 2.38443 12.5H0.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_8354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinWithHair);
export default __webpack_public_path__ + "static/media/skin-with-hair.b3f21dd1a8fe2599e392ca1fa0376f4f.svg";
export { ForwardRef as ReactComponent };